



















import {Component, Prop, Vue} from 'vue-property-decorator';
import ModuleItem from './moduleItem.vue';
import ModuleTemplateItem from './moduleTemplateItem.vue';
import CollapseBox from '@/components/collapseBox/collapseBox.vue';
import { classifyDataByKey, generateClassifications, ICollapseInfo, mergeClassifiedData } from '@/components/collapseBox/collapseBoxUtils';
import { AccountModule } from '@/store/modules/account';


type IModuleInfo = IModule.IResponse.IModuleInfo;
type IModuleTemplateInfo = IModule.IResponse.IModuleTemplateInfo;

@Component({
  components: {
    ModuleItem,
    CollapseBox,
    ModuleTemplateItem,
  },
})
export default class ModuleList extends Vue {
  @Prop({default: ''}) private activeId!: string;
  @Prop({default: false}) private spinning!: boolean;
  @Prop({required: true, default: () => []}) private data!: IModuleInfo[];
  @Prop({required: true, default: () => []}) private templates!: IModuleTemplateInfo[];

  get classifyDataByAccount() {
    // 根据账号对应的projects 生成 分类数据
    return generateClassifications(AccountModule.projects, 'id', 'name');
  }
  get dataByProjectCategory(): ICollapseInfo[] {
    const classifyData = classifyDataByKey(this.data, 'projectId', 'projectName');
    const moduleData = mergeClassifiedData(this.classifyDataByAccount, classifyData);
    this.templates.forEach((template) => {
      const category = moduleData.find((item) => item.key === template.projectId);
      if (category) {
        category.data.unshift(template);
      }
    });
    return moduleData;
  }
  private viewDetail(module: IModuleInfo | IModuleTemplateInfo) {
    this.$emit('click', module);
  }
}
